/**
 * Triggers a browser download of a Blob via a temporary anchor element.
 * Shared helper — previously duplicated across LedgerPage, ReportsPage and
 * MoveRequestsPage.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
